// src/environment/environment.dev.js
const environment = {
    API_URL: 'http://72.60.200.193/seo/api',
}

export default environment;
